// extracted by mini-css-extract-plugin
export default {"hideTooltip":"N_-z","fadeIn":"O_-z","delay":"P_-z","recommendedSizeTooltip":"Q_-z"};